const getters = {
};

const actions = {
  addLoading({ commit }, loadingToken) {
    commit('addLoading', loadingToken);
  },
  removeLoading({ commit }, loadingToken) {
    commit('removeLoading', loadingToken);
  },
  clearLoading({ commit }) {
    commit('clearLoading');
  },
  clearRequest({ commit }, state) {
    for (let i = 0; i < state.requestArray.length; i += 1) {
      if (state.requestArray[i].cancel) {
        // state.requestArray[i].cancel({ uuid: state.requestArray[i].uuid });
      }
    }
    commit('clearRequest');
  },
  removeRequest({ commit }, request) {
    commit('removeRequest', request);
  },
  addRequest({ commit }, request) {
    commit('addRequest', request);
  },
};

const mutations = {
  addLoading(state, loadingToken) {
    state.loadingArray.push(loadingToken);
  },
  removeLoading(state, loadingToken) {
    const loadingRequestIndex = state.loadingArray.findIndex((item) => item.uuid === loadingToken.uuid);
    state.loadingArray.splice(loadingRequestIndex, 1);
  },
  clearLoading(state) {
    state.loadingArray = [];
  },
  addRequest(state, request) {
    state.requestArray.push(request);
  },
  clearRequest(state) {
    state.requestArray = [];
  },
  removeRequest(state, request) {
    const requestIndex = state.requestArray.findIndex((item) => item.uuid === request.uuid);
    state.requestArray.splice(requestIndex, 1);
  },
};

const state = {
  loadingArray: [],
  requestArray: [],
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
